class UserListEntry {
    constructor({ id, stockId, symbol, companyName, score, thresholds = {}, isPriceIntraDay, marketRegularPrice = {}, marketCap, oneYearLow, oneYearHigh, change, changePercent, currency, plateformCustomExchange, scoreDetailsInfo }) {
        this._id = id;
        this._stockId = stockId;
        this._symbol = symbol || '';
        this._companyName = companyName;
        this._score = score;
        this._absoluteScore = this._score === -9999 ? this._score : Math.abs(this._score);
        this._threshold200 = thresholds.t200;
        this._threshold400 = thresholds.t400;
        this._threshold600 = thresholds.t600;
        this._threshold800 = thresholds.t800;
        this._isPriceIntraDay = isPriceIntraDay;
        this._lastPriceDateTime = marketRegularPrice.dateTime || Date.now;
        this._lastPrice = marketRegularPrice.value || 0.0;
        this._marketCap = marketCap;
        this._oneYearLow = oneYearLow;
        this._oneYearHigh = oneYearHigh;
        this._change = change || { value: 0.0 };
        this._changePercent = changePercent || { value: 0.0 };
        this._currency = currency;
        this._plateformCustomExchange = plateformCustomExchange;
        this._listId = undefined;
        this._scoreDetailsInfo = scoreDetailsInfo;
    }

    get id() { return this._id; }
    get stockId() { return this._stockId; }
    get symbol() { return this._symbol; }
    get companyName() { return this._companyName; }
    get score() { return this._score; }
    get absoluteScore() { return this._absoluteScore; }
    get threshold200() { return this._threshold200; }
    get threshold400() { return this._threshold400; }
    get threshold600() { return this._threshold600; }
    get threshold800() { return this._threshold800; }
    get isPriceIntraDay() { return this._isPriceIntraDay; }
    get lastPriceDateTime() { return this._lastPriceDateTime; }
    get lastPrice() { return this._lastPrice; }
    get marketCap() { return this._marketCap; }
    get oneYearLow() { return this._oneYearLow; }
    get oneYearHigh() { return this._oneYearHigh; }
    get change() { return this._change.value; }
    get changePercent() { return this._changePercent.value; }
    get currency() { return this._currency; }
    get plateformCustomExchange() { return this._plateformCustomExchange; }
    get listId() { return this._listId; }
    get scoreDetailsInfo() { return this._scoreDetailsInfo; }

    getThresholds() {
        return {
            t200: this._threshold200 || '',
            t400: this._threshold400 || '',
            t600: this._threshold600 || '',
            t800: this._threshold800 || ''
        }
    }

    toNumber(value) {
        const normalizeValue = typeof value === 'string' ? value.replace(',', '.') : value;
        return Number(normalizeValue);
    }

    set id(value) { this._id = value; }
    set stockId(value) { this._stockId = value; }
    set symbol(value) { this._symbol = value; }
    set companyName(value) { this._companyName = value; }
    set score(value) { this._score = value; }
    set absoluteScore(value) { this._absoluteScore = value; }
    set threshold200(value) { this._threshold200 = value; }
    set threshold400(value) { this._threshold400 = value; }
    set threshold600(value) { this._threshold600 = value; }
    set threshold800(value) { this._threshold800 = value; }
    set isPriceIntraDay(value) { this._isPriceIntraDay = value; }
    set lastPriceDateTime(value) { this._lastPriceDateTime = value; }
    set lastPrice(value) { this._lastPrice = value; }
    set marketCap(value) { this._marketCap = value; }
    set oneYearLow(value) { this._oneYearLow = value; }
    set oneYearHigh(value) { this._oneYearHigh = value; }
    set change(value) { this._change.value = value; }
    set changePercent(value) { this._changePercent.value = value; }
    set currency(value) { this._currency = value; }
    set plateformCustomExchange(value) { this._plateformCustomExchange = value; }
    set listId(value) { this._listId = value; }
    set scoreDetailsInfo(value) { this._scoreDetailsInfo = value; }

    setThresholds({ t200, t400, t600, t800 }) {
        this._threshold200 = this.toNumber(t200);
        this._threshold400 = this.toNumber(t400);
        this._threshold600 = this.toNumber(t600);
        this._threshold800 = this.toNumber(t800);
    }

    get rawData() {
        return {
            id: this._id,
            stockId: this._stockId,
            symbol: this._symbol,
            companyName: this._companyName,
            score: parseFloat(this._score || 0),
            absoluteScore: this._absoluteScore,
            currency: this.currency,
            thresholds: {
                T200: parseFloat(this._threshold200 || 0),
                T400: parseFloat(this._threshold400 || 0),
                T600: parseFloat(this._threshold600 || 0),
                T800: parseFloat(this._threshold800 || 0)
            },
            isPriceIntraDay: this._isPriceIntraDay,
            marketRegularDateTime: this._lastPriceDateTime,
            marketRegularPrice: parseFloat(this._lastPrice || 0),
            marketCap: parseFloat(this._marketCap || 0),
            oneYearLow: parseFloat(this._oneYearLow || 0),
            oneYearHigh: parseFloat(this._oneYearHigh || 0),
            change: parseFloat(this._change.value || 0),
            changePercent: parseFloat(this._changePercent.value || 0),
            plateformCustomExchange: this._plateformCustomExchange,
            scoreDetailsInfo: this._scoreDetailsInfo
        };
    }

    hasThresholds() {
        return this._threshold200 || this._threshold400 || this._threshold600 || this._threshold800;
    }
}

export default UserListEntry
